interface IService {
    price: string | number;
    description: string;
}

interface IItem {
    services?: IService[];
    [key: string]: any;
}

export function totalPriceCounter(items: IItem[]): number {
    return items.reduce((accum, item) => {
        const quantity = item.quantity ?? 1;
        const discount = item.discount ?? 0;
        const price = Number(item.price) || 0;

        const discountedPrice = (price * (100 - discount)) / 100;
        return accum + discountedPrice * quantity;
    }, 0);
}

export function calculateTotalPayment(
    data: { amount: number | string }[],
): number {
    return data.reduce((accum, item) => accum + Number(item.amount), 0);
}
